import environment from '../../environments';
import { JiraFieldConfig } from '../jira-server/jira-server.interface';

export interface ProductEntityConfig<T> {
  name?: string;
  idPrefix?: string;
  visibleJiraFields?: JiraFieldConfig[];
  enableRiskAssessment?: boolean;
  hideRiskField?: boolean;
  hideTestSteps?: boolean;
  useCustomInfoFields?: boolean;
  disableRelations?: T[];
}
export interface ProductConfig {
  userNeed?: ProductEntityConfig<
    'designInputs' | 'designSpecs' | 'verifications' | 'validations'
  >;
  designInput?: ProductEntityConfig<
    | 'userNeeds'
    | 'designOutputs'
    | 'verifications'
    | 'validations'
    | 'designSpecs'
  >;
  designOutput?: ProductEntityConfig<
    'designInputs' | 'verifications' | 'validations' | 'designSpecs'
  >;
  verification?: ProductEntityConfig<'designOutputs'>;
  validation?: ProductEntityConfig<'userNeeds' | 'designInputs'>;
  designSpec?: ProductEntityConfig<'userNeeds'>;
  hazard?: ProductEntityConfig<'userNeeds' | 'designInputs'>;
}

export const getProductEntityName = (key: keyof ProductConfig) => {
  switch (key) {
    case 'userNeed':
      return environment.productConfig?.userNeed?.name || 'User Need';
    case 'designInput':
      return environment.productConfig?.designInput?.name || 'Design Input';
    case 'designOutput':
      return environment.productConfig?.designOutput?.name || 'Design Output';
    case 'verification':
      return environment.productConfig?.verification?.name || 'Verification';
    case 'validation':
      return environment.productConfig?.validation?.name || 'Validation';
    case 'designSpec':
      return (
        environment.productConfig?.designSpec?.name || 'Design Specification'
      );
    case 'hazard':
      return environment.productConfig?.hazard?.name || 'Hazard';
    default:
      return '';
  }
};

export const getProductEntityIdPrefix = (key: keyof ProductConfig) => {
  switch (key) {
    case 'userNeed':
      return environment.productConfig?.userNeed?.idPrefix || 'UN';
    case 'designInput':
      return environment.productConfig?.designInput?.idPrefix || 'IN';
    case 'designOutput':
      return environment.productConfig?.designOutput?.idPrefix || 'OUT';
    case 'verification':
      return environment.productConfig?.verification?.idPrefix || 'VER';
    case 'validation':
      return environment.productConfig?.validation?.idPrefix || 'VAL';
    case 'designSpec':
      return environment.productConfig?.designSpec?.idPrefix || 'DS';
    default:
      return '';
  }
};

export const isProductRelationDisabled = (
  key: keyof ProductConfig,
  propertyKey: string
) => {
  return (
    environment.productConfig?.[key]?.disableRelations?.some(
      (r: string) => r === propertyKey
    ) || false
  );
};
